import { render, staticRenderFns } from "./ChatMiddleEmojiFace.vue?vue&type=template&id=f0e7def2&"
import script from "./ChatMiddleEmojiFace.vue?vue&type=script&lang=js&"
export * from "./ChatMiddleEmojiFace.vue?vue&type=script&lang=js&"
import style0 from "./ChatMiddleEmojiFace.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports